import { ofType } from 'redux-observable';
import { mergeMap, map, filter } from 'rxjs';
import { AppEpic } from 'src/store';
import { of } from 'rxjs';
import { isNil } from 'lodash';
import { fetchTopTyLyData, cleanUp, receiveTenantConfig, setGroupingInfo } from './TopTYvsLY.slice';
import {
  inputIsNotNullOrUndefined,
  isSameComponentType,
  isScopeDefined,
  isSubheaderLoaded,
  maybeGetComponentProps,
  topMemInWorklistSelected,
} from 'src/utils/Functions/epicsFunctions';
import { ConfDefnComponentType, ColumnGroupedViewComponent } from 'configuration-schemas/confdefnComponents';
import { isListDataApi } from 'configuration-schemas/confdefnView';
import { ExtraPivotOptions, getAggBys, organizeListDataOptions } from '../StyleColorReview.slice';
import {
  receiveScopeConfig,
  receiveScopeRefreshTrigger,
} from 'src/components/AssortmentScopeSelector/AssortmentScopeSelector.slice';
import { receiveFilterStateAfterSubmission } from 'src/components/FilterPanel/FilterPanel.slice';
import { updateSelectedItem } from 'src/pages/Worklist/Worklist.slice';
import { setActivePage, setActiveSubPage } from 'src/pages/NavigationShell/NavigationShell.slice';
import { emptySubheaderState } from 'src/components/Subheader/Subheader.slice';
import { receiveViewDefns } from 'src/components/Subheader/Subheader.slice';
import { LENS_ASST_PLAN_REFRESHING_PAGE } from 'src/pages/AssortmentBuild/Planning.types';
import { REQUEST_EXTERNAL_DATA_REFRESH } from 'src/components/higherOrder/GlobalDataRefresh';

export const topTyLyLoad: AppEpic = (action$, state$) => {
  return action$.pipe(
    ofType(
      receiveScopeRefreshTrigger.type,
      receiveFilterStateAfterSubmission.type,
      setActivePage.type,
      setActiveSubPage.type,
      updateSelectedItem.type,
      receiveTenantConfig.type,
      receiveScopeConfig.type,
      receiveViewDefns.type,
      LENS_ASST_PLAN_REFRESHING_PAGE,
      REQUEST_EXTERNAL_DATA_REFRESH,
    ),
    map(() => maybeGetComponentProps<ColumnGroupedViewComponent>(state$.value, ConfDefnComponentType.topTyLy)),
    filter(inputIsNotNullOrUndefined),
    filter(() => topMemInWorklistSelected(state$.value)),
    filter(() => isScopeDefined(state$.value.scope) && isSubheaderLoaded(state$.value.subheader)),
    mergeMap(({ defns, groupingInfo }) => {
      const { dataApi, model: modelDefn } = defns;
      const finalModelDefn = isListDataApi(dataApi) ? dataApi.defnId : modelDefn;

      const topMembers = state$.value.worklist.selectedItemId;
      // We use a custom aggby for this screen, so we don't need the subheader agg by information.
      const aggBy = getAggBys(emptySubheaderState.groupBy, dataApi);
      const options: ExtraPivotOptions = !isNil(topMembers) ? { topMembers, aggBy } : { aggBy };
      const finalOptions = organizeListDataOptions(options, dataApi);

      if (isSameComponentType<ColumnGroupedViewComponent>(state$.value, ConfDefnComponentType.topTyLy)) {
        return of(cleanUp(), setGroupingInfo(groupingInfo), fetchTopTyLyData(finalModelDefn, finalOptions));
      }

      return of(setGroupingInfo(groupingInfo), fetchTopTyLyData(finalModelDefn, finalOptions));
    }),
  );
};
